var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-title',[_vm._v("My Permissions")]),_c('b-card-text',[_vm._v(" Your current account permissions are listed below. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }